export default "__VITE_ASSET__e9ee850d__"